module.exports = __webpack_public_path__ + "static/media/mercecharge.3dca4257.jpg";